<template>
  <section class="certified border">
    <div class="container">
      <div class="video-container">
        <!-- <video src="@/static/video/video.mp4" autoplay loop muted />
        <img src="@/static/video/video-preview.jpg" alt />-->
        <!-- <img :src="data.image" alt /> -->
        <video
          onloadeddata="this.play();"
          poster="@/static/video/video-preview.jpg"
          playsinline
          loop
          muted
          id="video"
        >
          <source src="@/static/video/video.mp4" type="video/mp4" />Your browser does not support the video tag or the file format of this video.
        </video>

        <div class="container-info">
          <div class="info-area" v-html="data.area" />
          <div class="info-title" v-html="data.title" />
          <div class="info-text" v-html="data.text" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["data"],
  mounted() {
    document.getElementById("video").play();
  },
};
</script>

<style lang="scss" src="./Certified.scss" />